module.exports = __webpack_public_path__ + "static/pwe-exp-6688c794e7307bb952be34f917eefd5b.svg";